import { render, staticRenderFns } from "./Complate.vue?vue&type=template&id=19660474&"
import script from "./Complate.vue?vue&type=script&lang=js&"
export * from "./Complate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports